<template>
  <AppBanner>
    Add a District
  </AppBanner>

  <template v-if="loading">
    <AppContentLoader
      :is-loading="loading"
      text="Loading district..."
    />
  </template>

  <template v-else>
    <DistrictForm
      :provinces="provinces"
    />
  </template>
</template>

<script setup>
import { HttpStatusCode } from 'axios';
import { onMounted, ref } from 'vue';

import { AppContentLoader } from '@/components/app';
import { AppBanner } from '@/components/banners';
import { DistrictForm } from '@/components/forms';

import { useHttp } from '@/composables';

const loading = ref(true);
const provinces = ref(null);

onMounted(async () => {
  await loadProvinces();

});

const loadProvinces = async () => {
  loading.value = true;

  const response = await useHttp().get('/util/provinces');

  if (response.statusCode === HttpStatusCode.Ok) {
    provinces.value = response.data.items;
  }

  loading.value = false;
};

</script>
